import { Button, TextField } from "@mui/material";
import styles from "./addrole.module.css";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useEffect } from "react";

const schema = yup.object().shape({
    name: yup.string().required('This field is Required').max(20, 'Name cannot be more than 20 characters'),
    description: yup.string().required('This field is Required').max(200, 'Description cannot be more than 200 characters'),
});

const AddRole = ({ setAddModalOpen, roleData, setAddRoleStep, setNewRoleData }) => {

    const { handleSubmit, control, errors, setValue } = useForm({
        resolver: yupResolver(schema), mode: 'onChange',
        defaultValues: {
            name: '',
            description: ''
        }
    });

    useEffect(() => {
        if (roleData) {
            setValue('name', roleData?.name);
            setValue('description', roleData?.description);
        }
    }, [roleData, setValue]);

    const onSubmit = async (data) => {
        setAddRoleStep(2);
        setNewRoleData(data);
    }

    const onUpdate = async (data) => {
        setAddRoleStep(2);
        setNewRoleData(data);
    }

    return (<div>
        <form onSubmit={handleSubmit(roleData ? onUpdate : onSubmit)}>
            <div className={`${styles.ReqAddRow}`}>
                <div className={`${styles.ReqAddFormSec}`}>
                    <div className={`${styles.FormSecRow}`}>
                        <div className={`${styles.FormGroupFull} FormGroup`}>
                            <Controller
                                name={`name`}
                                control={control}
                                render={(field) => (<TextField  {...field} id="outlined-basic" label="Name*" variant="outlined" />)}
                            />
                            {errors.name && (<p className={`${styles.ErrorM}`}>{errors?.name?.message}</p>)}
                        </div>
                        <div className={`${styles.FormGroupFull} FormGroup`}>
                            <Controller
                                name={`description`}
                                control={control}
                                render={(field) => (<TextField {...field} id="outlined-basic" label="Description*" variant="outlined" multiline rows={8} />)}
                            />
                            {errors.description && (<p className={`${styles.ErrorM}`}>{errors?.description?.message}</p>)}
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${styles.ButtonActionTwo}`}>
                <Button onClick={(e) => setAddModalOpen(false)} className="CancelPopupBU">Cancel</Button>
                <Button className="SubmitPopupBU" type="submit">Next</Button>
            </div>
        </form>
    </div>)
}

export default AddRole;
